/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  OnInit,
} from "@angular/core";
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormsModule,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SelectModule } from "primeng/select";
import { US_STATES, USState } from "../../core/constants/us-states";

@Component({
  selector: "app-state-select",
  imports: [CommonModule, FormsModule, SelectModule],
  templateUrl: "./state-select.component.html",
  styleUrl: "./state-select.component.scss",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StateSelectComponent),
      multi: true,
    },
  ],
})
export class StateSelectComponent implements ControlValueAccessor, OnInit {
  @Input() placeholder: string = "Select State";
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() styleClass: string = "w-full";
  @Input() appendTo: string | HTMLElement | null = null;
  @Output() selectionChange = new EventEmitter<string>();

  states: USState[] = US_STATES;
  stateOptions: { label: string; value: string }[] = [];
  selectedValue: string | null = null;

  private onChange: (value: string | null) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit(): void {
    // Convert states to dropdown options
    this.stateOptions = this.states.map((s) => ({
      label: `${s.name} (${s.abbreviation})`,
      value: s.abbreviation,
    }));
  }

  // ControlValueAccessor implementation
  writeValue(value: string | null): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // Handle selection change
  onStateChange(event: any): void {
    const value = event.value;
    this.selectedValue = value;
    this.onChange(value);
    this.onTouched();
    this.selectionChange.emit(value);
  }
}
